import { CountryCodeEnum } from '../../../../types/forms';
import { PrivateProspectFormModel } from './formModel';

export const getInitialValues = (): PrivateProspectFormModel => {
  return {
    firstName: '',
    lastName: '',
    countryCode: CountryCodeEnum.Ireland,
    mobileNumber: '',
    email: '',
    vulnerableCustomer: false,
    storeQuoteTwelveMonths: undefined,
  };
};
